var $window = $(window),
	ww = $window.width(),
	wh = $window.height(),
	wb = $(window).scrollTop() + wh,
	$footer = $('.js-footer'),
	fh = $footer.outerHeight(),
	shapeRatio = 9.857;

function maxWidthLg(fc1, fc2) {
	var fc1 = fc1 || function(){},
		fc2 = fc2 || function(){};

	if (ww >= 1200) {
		fc1();
	} else {
		fc2();
	};
};

function maxWidthMd(fc1, fc2) {
	var fc1 = fc1 || function(){},
		fc2 = fc2 || function(){};

	if (ww >= 991) {
		fc1();
	} else {
		fc2();
	};
};

function maxWidthSm(fc1, fc2) {
	var fc1 = fc1 || function(){},
		fc2 = fc2 || function(){};

	if (ww >= 768) {
		fc1();
	} else {
		fc2();
	};
};

function globalScripts() {
	ww = $window.width();
	wh = $window.height();
	fh = $footer.outerHeight();

	if ($("#js-nav-fixed").length) {
		fixedNav();
	};

	if ($('.js-full-h').length) {
		fullHeightPage();
	};

	if ($('.js-shape-top').length) {
		shapeTop();
	};

	if ($('.js-shape-bottom').length) {
		shapeBottom();
	};

	if ($('.js-last-block').length) {
		shapeBottomSize();
	};

	if ($('.js-disable-hover').length) {
		disableHover();
	}

	if ($('.cover-img').length) {
		bgCover();
	}
}

$(function(){
	globalScripts();

	$window.resize(function(){
		globalScripts();
	});

	$window.on('scroll', function(){
		wb = $(window).scrollTop() + wh;
	})
});